export type MasterOption = { value: string; label: string };

export type CollectorMastersCatalog = {
  itemCategories: MasterOption[];
  colors: MasterOption[];
  occasions: MasterOption[];
  craftTypes: MasterOption[];
  fabrics: MasterOption[];
  clusters: MasterOption[];
};

const OTHER: MasterOption = { value: "other", label: "Other" };

const withOther = (options: MasterOption[]): MasterOption[] => {
  const without = options.filter((opt) => opt.value.toLowerCase() !== "other");
  return [...without, OTHER];
};

export const FALLBACK_MASTERS: CollectorMastersCatalog = {
  itemCategories: withOther([
    { value: "saree", label: "Saree" },
    { value: "shawl", label: "Shawl" },
    { value: "dupatta", label: "Dupatta" },
    { value: "art_piece", label: "Art piece" },
    { value: "home_decor", label: "Home decor" },
    { value: "jewellery", label: "Jewellery" },
  ]),
  colors: withOther([
    { value: "maroon", label: "Maroon" },
    { value: "gold", label: "Gold" },
    { value: "ivory", label: "Ivory" },
    { value: "black", label: "Black" },
    { value: "red", label: "Red" },
    { value: "green", label: "Green" },
    { value: "blue", label: "Blue" },
    { value: "white", label: "White" },
    { value: "beige", label: "Beige" },
    { value: "multi", label: "Multi" },
  ]),
  occasions: withOther([
    { value: "wedding", label: "Wedding" },
    { value: "festival", label: "Festival" },
    { value: "gift", label: "Gift" },
    { value: "travel", label: "Travel" },
    { value: "heirloom", label: "Heirloom" },
  ]),
  craftTypes: withOther([
    { value: "Banarasi", label: "Banarasi" },
    { value: "Kanjeevaram", label: "Kanjeevaram" },
    { value: "Pichwai", label: "Pichwai" },
    { value: "Kalamkari", label: "Kalamkari" },
    { value: "Chikankari", label: "Chikankari" },
    { value: "Bandhani", label: "Bandhani" },
    { value: "Ikat", label: "Ikat" },
    { value: "Patola", label: "Patola" },
    { value: "Madhubani", label: "Madhubani" },
    { value: "Warli", label: "Warli" },
    { value: "Dhokra", label: "Dhokra" },
    { value: "Pattachitra", label: "Pattachitra" },
  ]),
  fabrics: withOther([
    { value: "silk", label: "Silk" },
    { value: "cotton", label: "Cotton" },
    { value: "wool", label: "Wool" },
    { value: "linen", label: "Linen" },
    { value: "mix", label: "Mix" },
  ]),
  clusters: withOther([
    { value: "Banaras", label: "Banaras" },
    { value: "Kanchipuram", label: "Kanchipuram" },
    { value: "Bhuj", label: "Bhuj" },
    { value: "Jaipur", label: "Jaipur" },
  ]),
};

export const selectState = (value: string, options: MasterOption[]) => {
  if (!value) {
    return { select: "", otherText: "" };
  }
  if (value.toLowerCase() === "other") {
    return { select: "other", otherText: "" };
  }
  const match = options.find(
    (opt) => opt.value === value && opt.value.toLowerCase() !== "other"
  );
  if (match) {
    return { select: match.value, otherText: "" };
  }
  return { select: "other", otherText: value };
};

export const storedMasterValue = (value?: string) => {
  if (!value || value.toLowerCase() === "other") return "";
  return value;
};

export const normalizeMasters = (raw?: Partial<CollectorMastersCatalog> | null): CollectorMastersCatalog => ({
  itemCategories: withOther(raw?.itemCategories?.length ? raw.itemCategories : FALLBACK_MASTERS.itemCategories),
  colors: withOther(raw?.colors?.length ? raw.colors : FALLBACK_MASTERS.colors),
  occasions: withOther(raw?.occasions?.length ? raw.occasions : FALLBACK_MASTERS.occasions),
  craftTypes: withOther(raw?.craftTypes?.length ? raw.craftTypes : FALLBACK_MASTERS.craftTypes),
  fabrics: withOther(raw?.fabrics?.length ? raw.fabrics : FALLBACK_MASTERS.fabrics),
  clusters: withOther(raw?.clusters?.length ? raw.clusters : FALLBACK_MASTERS.clusters),
});
